import { Button, SxProps, useTheme, styled, DialogContent, DialogActions, Box } from "@mui/material";
import {
    StyleguideSavioColors,
    StyleguideSavioFonts,
    themeSettings,
} from "../../../configuration/themeSettings";
import { DataGrid } from "@mui/x-data-grid";

export const StyledButtonUplodBasket = styled(Button, {
    label: "AppBasketUpload-Button",
})(({ theme: Theme }) => ({
    width: "170px",
}));

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    color: themeSettings.main.palette.primary.main,
    fontFamily: themeSettings.main.typography.fontFamily,
    WebkitFontSmoothing: "auto",
    letterSpacing: "normal",
    border: '1px solid ' + themeSettings.main.palette.primary.main,

    ".MuiDataGrid-footerContainer":
    {
        display: "none",
    },

    "& .MuiDataGrid-columnsContainer": {
        backgroundColor: "#1d1d1d",
        ...theme.applyStyles("light", {
            backgroundColor: "#fafafa",
        }),
    },
    "& .MuiDataGrid-iconSeparator": {
        display: "none",
    },

    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
        borderRight: "1px solid #303030",
        ...theme.applyStyles("light", {
            borderRightColor: "#f0f0f0",
        }),
    },
    "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
        borderBottom: "1px solid #303030",
        ...theme.applyStyles("light", {
            borderBottomColor: "#f0f0f0",
        }),
    },

    "& .MuiDataGrid-cell": {
        color: StyleguideSavioColors.text.black,
        backgroundColor: StyleguideSavioColors.footerGrey + " !important",

        '&:focus': {
            outline: '1px solid ' + themeSettings.main.palette.primary.main,
        },

        '&:nth-of-type(2)': { backgroundColor: '#fff !important', }
    },
    '.MuiDataGrid-cell--editable': {
        cursor: 'cell', backgroundColor: '#fff !important',
    },
    "& .MuiPaginationItem-root": {
        borderRadius: 0,
    },
    ".selected-row": {
        backgroundColor: StyleguideSavioColors.footerGrey,
        color: theme.palette.primary.main,
    },

    ".top": {
        borderTop: "1px solid " + themeSettings.main.palette.primary.main,
    },
    ".bottom": {
        borderBottom: "1px solid " + themeSettings.main.palette.primary.main,
    },
    ".left": {
        borderLeft: "1px solid " + themeSettings.main.palette.primary.main,
    },
    ".right": {
        borderRight: "1px solid " + themeSettings.main.palette.primary.main + " !important",
    },

    ".selected-cell": {
        backgroundColor: StyleguideSavioColors.footerGrey,
        color: theme.palette.primary.main,
    },

    '.primaryColor': {
        color: theme.palette.primary.main,
    },
    '.icon': {
       // width: 50,
        padding: 0,
        '*:not(.leftTopCorner )': {
            width: '100%',
            height: '100%',
        }
    },
    '.MuiDataGrid-cell':{
        '&[data-field="manufacturerCompanyCode"]':{
            
            '.MuiInputBase-input':{fontSize: 14,}
        }
    }

}));


export const DialogContentStyled = styled(DialogContent, {
    label: "dialog-content-styled",
})(({ theme }) => ({
    paddingLeft: 13,
    paddingRight: 13,
    paddingTop: "20px !important",
    borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
}));

export const StyledDialogActions = styled(DialogActions, {
    label: "StyledDialogActions",
})(({ theme: Theme }) => ({
    paddingLeft: 13,
    paddingRight: 13,
    paddingBottom: 8,
    display: 'flex',
    justifyContent: 'space-between',

    '> div': {

        '&:first-of-type': {
            display: 'flex',
            flexDirection: 'column',
            'p': {
                fontSize: 12,
            }
        },

        '&:last-child': {
            display: 'flex',
            flexShrink: 0,

        }
    }

}));


export const HeadContentTable = styled(Box, {
    label: "HeadContentTable",
})(({ theme: Theme }) => ({
    display: 'flex',
    marginBottom: 15,
    justifyContent: 'space-between',
    gap: 10,
    '> div': {


        '&:first-of-type': {
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
        },

        '&:last-child': {
            display: 'flex',
            flexShrink: 0,



            'button': {
                '&:last-child': {
                    marginTop: 10,
                }
            }
        }
    }

}));


export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        leftTopCorner: {
            width: '100%',
            height: '100%',

            '&:before': {
                content: "''",
                display: 'block',
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "0 0 13px 13px",
                borderColor:
                    "transparent transparent " +
                    StyleguideSavioColors.lightGrey +
                    " transparent",
            }
        },
        excel: {
            fontWeight: StyleguideSavioFonts.normal,
            color: StyleguideSavioColors.text.black,
            fontSize: "12px !important",
            "& input": {
                color: StyleguideSavioColors.text.black,
                fontWeight: StyleguideSavioFonts.normal,
                fontSize: "12px !important",
            },
            "& div.dsg-cell-header": {
                color: StyleguideSavioColors.blue,
            },
            "& div.dsg-cell-gutter": {
                color: StyleguideSavioColors.blue,
            },

            '.MuiDataGrid-root':{
                border: 0,
            },


            '.MuiDataGrid-columnHeader':{
                borderBottom: '1px solid ' + StyleguideSavioColors.mainBlue + ' !important',
                '.MuiDataGrid-columnHeaderTitle':{
                    fontWeight: StyleguideSavioFonts.bold,
                }
            }
        } as SxProps,
        grid: {
            border: "2px",
            borderColor: "green",
        },
    };
    return classes;
};
